import Align from './align';
import dataStore from '../../../data/data';
import runLandmarksStream from '../landmarks-stream';
import Crop from './crop';

export async function StreamLandmarkMedia(canvasRef,cleanupRef,streamRef,videoRef){
  const data = dataStore.getState();
  const camera = data.mirror.camera;
  const setData=dataStore.setState;

  const mediaStream = await navigator.mediaDevices.getUserMedia({
    video: camera
      ? {
          deviceId: {
            exact: camera
          }
        }
      : true,
  });

  streamRef.current = mediaStream;

  if (videoRef.current) {
    videoRef.current.srcObject = mediaStream;

    await new Promise((resolve) => {
      const v = videoRef.current;
      if (v.readyState >= 2) return resolve();
      v.onloadeddata = () => resolve();
    });

    await videoRef.current.play();
    cleanupRef.current = await runLandmarksStream(
      videoRef.current,
      (results) => {
        const canvas = canvasRef.current;
        const video = videoRef.current;

        if (!canvas || !video) return;

        const ctx = canvas.getContext('2d');

        if (!canvas.dataset.sized) {
          if (video.videoWidth === 0 || video.videoHeight === 0) return;
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.dataset.sized = "true";
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (!results.faceLandmarks?.length) return;

        const landmarks = results.faceLandmarks[0];

        const initializedPeer=data.mediaprocessing.peer.face.cast.landmarks.initialized;
        const initializedVitruvian=data.mediaprocessing.vitruvian.face.cast.landmarks.initialized;
        const initialized=[initializedPeer,initializedVitruvian];
 
        if (!initialized.every(Boolean)){
          setData((_data) => ({
            ..._data,
            mediaprocessing:{
              ..._data.mediaprocessing,
              peer:{
                ..._data.mediaprocessing.peer,
                face:{
                  ..._data.mediaprocessing.peer.face,
                  cast:{
                    ..._data.mediaprocessing.peer.face.cast,
                    landmarks: {
                      ..._data.mediaprocessing.peer.face.cast.landmarks,
                      init: landmarks.map(l => ({ ...l })),
                      initialized: true,
                    },
                  }
                }
              },
              vitruvian:{
                ..._data.mediaprocessing.vitruvian,
                face:{
                  ..._data.mediaprocessing.vitruvian.face,
                  cast:{
                    ..._data.mediaprocessing.vitruvian.face.cast,
                    landmarks: {
                      ..._data.mediaprocessing.vitruvian.face.cast.landmarks,
                      init: landmarks.map(l => ({ ...l })),
                      initialized: true,
                    },
                  }
                }
              }
            }
          }));
        }

        const croppedPeerLandmarks=Crop(dataStore.getState().mediaprocessing.peer.face.cast.landmarks.live);
        Align(croppedPeerLandmarks,'peer');
        
        const croppedVitruvianLandmarks=Crop(landmarks);
        Align(croppedVitruvianLandmarks,'vitruvian');

        ctx.fillStyle = 'cyan';

        for (const point of landmarks) {
          const x = point.x * canvas.width;
          const y = point.y * canvas.height;

          ctx.beginPath();
          ctx.arc(x, y, 2, 0, 2 * Math.PI);
          ctx.fill();
        }
      }
    );
  }
}

export async function StreamAudioMedia() {
  const data=dataStore.getState();
  const deviceId=data?.mirror?.audio?.device?.id;

  const mediaStream = await navigator.mediaDevices.getUserMedia({
    audio: deviceId
      ? {
          deviceId: { exact: deviceId },
          echoCancellation:false,
          noiseSuppression:false,
          autoGainControl:false,
        }:{
          echoCancellation:false,
          noiseSuppression:false,
          autoGainControl:false,
        },
    video: false,
  });

  return mediaStream;
}
